import React, { useMemo, useState, useEffect, useRef } from "react"
import "./ContactReferrals.scss"
import Button from "@mui/material/Button"
import { useTable, useSortBy, useGlobalFilter } from "react-table"
// import { COLUMNS } from "./ContactReferralsColumns"
import { GlobalFilter } from "../../../frontDesk/patientDirectory/GlobalFilter"
import { useHistory } from "react-router"
import { useSelector } from "react-redux"
import {
  getAllCenters,
  getAllConsultantReferralDetails,
} from "../../../../core/services/api"
import { deleteConsultantDetail } from "../../../../core/services/api"
import Toast from "../../../../components/Toast"
import { MocUserRole } from "core/services/models/Enums"

function ContactReferrals() {
  const [centers, setCenters] = useState([])
  const COLUMNS = [
    {
      Header: "Name",
      accessor: "consultantName",
    },
    {
      Header: "Specialization",
      accessor: "specialization",
    },
    {
      Header: "Phone",
      accessor: "phoneNumber",
    },
    {
      Header: "Email",
      accessor: "emailId",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        // let email = cell?.value?.toLowerCase()
        let email = cell?.value?.charAt(0).toLowerCase() + cell?.value?.slice(1)
        return <div>{email}</div>
      },
    },
    {
      Header: "Centers",
      accessor: "centerIds",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        const temp = cell?.value?.map((ele) => {
          // @ts-ignore
          const found = centers?.filter((each) => each?.id === ele)
          if (found?.length > 0) {
            return found[0]?.name
          } else {
            return ""
          }
        })
        return (
          <ol>
            {temp?.length > 0 &&
              // @ts-ignore
              temp?.map((ele) => {
                return <li>{ele}</li>
              })}
          </ol>
        )
      },
    },
    {
      Header: "",
      accessor: "Edit",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        let readOnly = useSelector((state) => state?.user?.readOnly)
        if (readOnly) return null
        else
          return (
            <img
              className="eye-icon"
              src={"assets/images/CRedit.svg"}
              width={32}
              height={30}
              style={{
                marginTop: "6px",
                paddingRight: "15px",
                width: "40px",
                height: "40px",
              }}
              alt="eye"
            />
          )
      },
    },
    {
      Header: "",
      accessor: "Delete",
      // @ts-ignore
      Cell: ({ cell }) => {
        // @ts-ignore
        let readOnly = useSelector((state) => state?.user?.readOnly)
        if (readOnly) return null
        else
          return (
            <img
              className="eye-icon"
              src={"assets/images/CRdelete.svg"}
              width={32}
              height={30}
              style={{
                marginTop: "6px",
                paddingRight: "15px",
                width: "40px",
                height: "40px",
              }}
              alt="eye"
            />
          )
      },
    },
  ]
  const [data, setData] = useState([])
  const columns = useMemo(() => COLUMNS, [centers])
  const componentRef = useRef()
  const history = useHistory()
  const [displayToast, toggleDisplayToast] = useState()
  // @ts-ignore
  const readOnly = useSelector((state) => state?.user?.readOnly)
  // @ts-ignore
  const userDetail = useSelector((state) => state?.user?.userDetail)
  // @ts-ignore
  const userRole = useSelector((state) => state?.user?.role)

  useEffect(() => {
    getAllCenters()
      .then((res) => {
        // @ts-ignore
        const temp = res?.map((each) => {
          return {
            name: each?.centerName,
            mocId: each?.mocCenterId,
            id: each?.id,
          }
        })
        setCenters(temp)
      })
      .catch((err) => console.log(err?.message))
  }, [])

  useEffect(() => {
    // @ts-ignore
    if (userRole === MocUserRole.CENTER_ADMIN) {
      getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId)
        .then((res) => {
          setData(res)
        })
        .catch((err) => {
          console.log("err", err)
        })
    } else {
      getAllConsultantReferralDetails("")
        .then((res) => {
          setData(res)
        })
        .catch((err) => {
          console.log("err", err)
        })
    }
  }, [])

  /**
   * @param {any} path
   */
  const redirectTo = async (path) => {
    history.push({
      pathname: "/addNewReferrals",
      state: { idValue: path },
    })
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
    },

    useGlobalFilter,
    useSortBy
  )
  const { globalFilter } = state
  // @ts-ignore
  const handleDelete = (path) => {
    deleteConsultantDetail(`${path}`)
      // @ts-ignore
      // @ts-ignore
      // @ts-ignore
      .then((res) => {
        // @ts-ignore
        // @ts-ignore
        toggleDisplayToast({
          text: "Referral doctor has been successfully deleted",
          type: "success",
        })
        // })
        if (userRole === MocUserRole.CENTER_ADMIN) {
          getAllConsultantReferralDetails(userDetail?.currentCenter?.centerId)
            .then((res) => {
              setData(res)
            })
            .catch((err) => {
              console.log("err", err)
            })
        } else {
          getAllConsultantReferralDetails("")
            .then((res) => {
              setData(res)
            })
            .catch((err) => {
              console.log("err", err)
            })
        }
      })
      .catch((err) => {
        console.log("err", err)
        // @ts-ignore
        toggleDisplayToast({
          text: "Failed to delete referral doctor",
          type: "error",
        })
      })
  }

  return (
    <div className="contact-referrals-wrapper">
      <div className="contact-referrals-heading">
        <div
          className="approval-back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"
          />
        </div>

        <div className="manage-staff-text">Contact - Referral Doctors</div>
      </div>
      <div className="contact-referral-container">
        <div className="row add-new">
          <div className="col-9"></div>
          <div className="col-3 add-new-text">
            <Button
              className={`button-container ${
                readOnly ? "read-only-button" : ""
              }`}
              onClick={() => history.push(`/AddNewReferrals`)}
              id="add-new-referral-doctor"
              disabled={readOnly}
            >
              Add New Referral Doctor
            </Button>
          </div>
          <div className="search-container">
            <div>
              <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
            {/* <div> */}
            {/* <Dropdown placeholder="All" selected=""></Dropdown> */}
            {/* </div> */}
          </div>
          <div className={readOnly ? "read-only" : ""}>
            <table
              {...getTableProps()}
              // @ts-ignore
              ref={componentRef}
            >
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => {
                      return column?.Header !== "Centers" ? (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ) : column?.Header === "Centers" &&
                        userRole !== MocUserRole.CENTER_ADMIN ? (
                        <th {...column.getHeaderProps()}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                              paddingLeft: "40px",
                            }}
                          >
                            {column.render("Header")}
                          </div>
                        </th>
                      ) : null
                    })}
                  </tr>
                ))}
              </thead>

              <tbody
                className="border-radiusImportant"
                {...getTableBodyProps()}
              >
                {rows.map((row) => {
                  prepareRow(row)
                  return (
                    <tr {...row.getRowProps()} style={{ cursor: "pointer" }}>
                      {row.cells.map((cell) => {
                        return cell?.column?.Header !== "Centers" ? (
                          <td
                            onClick={() => {
                              if (readOnly) return null
                              else {
                                if (
                                  cell?.column?.id?.toLowerCase() === "delete"
                                ) {
                                  toggleDisplayToast({
                                    // @ts-ignore
                                    text: `Are you sure you want to delete the referral doctor?`,
                                    type: "warning",
                                    onClickText: "Yes",
                                    // @ts-ignore
                                    patient: cell?.row?.original?.id,
                                  })
                                }
                                if (
                                  cell?.column?.id?.toLowerCase() === "edit"
                                ) {
                                  // @ts-ignore
                                  redirectTo(row?.original?.id)
                                }
                              }
                            }}
                            style={{
                              maxWidth:
                                userRole === MocUserRole?.CENTER_ADMIN
                                  ? "17%"
                                  : "150px",
                              width:
                                userRole === MocUserRole?.CENTER_ADMIN
                                  ? "17%"
                                  : "150px",
                              wordWrap: "break-word",
                              maxHeight: "100px",
                              paddingLeft: "40px",
                              verticalAlign: "left",
                              fontSize: "18px",
                              lineHeight: "24px",
                              letterSpacing: "1.35px",
                              textAlign: "initial",
                              // textTransform: "lowercase",
                            }}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        ) : cell?.column?.Header == "Centers" &&
                          userRole !== MocUserRole.CENTER_ADMIN ? (
                          <td
                            onClick={() => {
                              if (readOnly) return null
                              else {
                                if (
                                  cell?.column?.id?.toLowerCase() === "delete"
                                ) {
                                  toggleDisplayToast({
                                    // @ts-ignore
                                    text: `Are you sure you want to delete the referral doctor?`,
                                    type: "warning",
                                    onClickText: "Yes",
                                    // @ts-ignore
                                    patient: cell?.row?.original?.id,
                                  })
                                }
                                if (
                                  cell?.column?.id?.toLowerCase() === "edit"
                                ) {
                                  // @ts-ignore
                                  redirectTo(row?.original?.id)
                                }
                              }
                            }}
                            style={{
                              maxWidth: "150px",
                              width: "150px",
                              wordWrap: "break-word",
                              maxHeight: "100px",
                              paddingLeft: "40px",
                              verticalAlign: "left",
                              fontSize: "18px",
                              lineHeight: "24px",
                              letterSpacing: "1.35px",
                              textAlign: "initial",
                              // textTransform: "lowercase",
                            }}
                            {...cell.getCellProps()}
                          >
                            {cell.render("Cell")}
                          </td>
                        ) : null
                      })}
                    </tr>
                  )
                })}
              </tbody>
              <tfoot>
                {footerGroups.map((footerGroup) => (
                  <tr {...footerGroup.getFooterGroupProps()}>
                    {footerGroup.headers.map((column) => (
                      <td {...column.getFooterProps()}>
                        {column.render("Footer")}
                      </td>
                    ))}
                  </tr>
                ))}
              </tfoot>
            </table>
          </div>
        </div>
        {displayToast && (
          <Toast
            // @ts-ignore
            textMessage={displayToast?.text}
            // @ts-ignore
            onClose={() => toggleDisplayToast(false)}
            onCloseText="Close"
            onClickText={
              // @ts-ignore
              displayToast?.onClickText ? displayToast?.onClickText : null
            }
            onClick={() =>
              // @ts-ignore
              displayToast?.patient
                ? // @ts-ignore
                  handleDelete(displayToast?.patient)
                : null
            }
            // @ts-ignore
            type={displayToast?.type}
          />
        )}
      </div>
    </div>
  )
}
export default ContactReferrals
